<div class="modal fade" id="{{modalId}}" role="dialog" data-bs-backdrop="static">
	<div class="modal-dialog modal-lg">
		<div class="modal-content">
			<div *ngIf="pageLoading1" class="loader text-center">
				<img src="../../assets/img/loading.gif" />
				<p style="color: black;font-weight: bolder;">Loading...</p>
			</div>
			<form [formGroup]="moduleForm" (ngSubmit)="saveData()" #modform="ngForm">
				<div class="modal-header text-center row g-1">
					<h4 class="modal-title mb-0 col-11 text-start">
						<strong>
							Update leave balance
						</strong>
					</h4>
					<div class="col-1 text-end">
						<button type="button" class="btn-close" (click)="clearForm();"></button>
					</div>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-12">
							<div class="row mb-3">
								<div class="col-6">
									<div class="ng-select-material">
										<ng-select [items]="userList" bindValue="emp_code" bindLabel="full_name"
											[clearable]="true" placeholder="Employee*" formControlName="emp_code"
											id="emp_code_lb" appearance="outline" [groupBy]="'department_name'"
											[ngClass]="{'is-invalid':showError('emp_code')}" (change)="empChanged()">
										</ng-select>
									</div>
									<p *ngIf="showError('emp_code')" class="text-danger">
										<span *ngIf="f.emp_code.errors?.required">
											Required
										</span>
									</p>
								</div>
								<div class="col-6">
									<div class="form-floating">
										<input class="form-control" [ngClass]="{'is-invalid':showError('lb')}"
											id="lb_lb" formControlName="lb" placeholder="">
										<label>Leave Balance*</label>
									</div>
									<p *ngIf="showError('lb')" class="text-danger">
										<span *ngIf="f.lb.errors?.required">
											Required
										</span>
										<span *ngIf="f.lb.errors?.pattern">
											Invalid
										</span>
									</p>
								</div>
							</div>
							<div class="row mb-3">
								<div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
									<button type="submit" class="btn btn-sm btn-primary me-1">
										<fa-icon *ngIf="!showLoader" [icon]="['fas', 'save']"></fa-icon>
										<fa-icon *ngIf="showLoader" [icon]="['fas', 'spinner']"
											animation="spin"></fa-icon>
										Submit
									</button>
									<button type="button" class="btn btn-sm btn-secondary"
										(click)="clearForm();">Cancel</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</div>